var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPvroofDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8f8f8f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m63.707 32.293-18-18a.426.426 0 0 0-.093-.071A.984.984 0 0 0 45 14h-2.586l3.293-3.293A1 1 0 0 0 45 9H19a.996.996 0 0 0-.707.293l-18 18A1 1 0 0 0 1 29h2.586L.293 32.293A1 1 0 0 0 1 34h2v20a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V34h2a1 1 0 0 0 .707-1.707zM39.294 14.292l-.002.002L35.586 18h-6.172l7-7h6.172zM11.414 27l7-7h6.172l-7 7zm22.172-16-7 7h-6.172l7-7zm-6.172 9h6.172l-7 7h-6.172zm-8-9h5.172l-7 7h-5.172zm-9 9h5.172l-7 7H3.414zm-4 9H27c.266 0 .519-.106.707-.293L40.414 16h2.172l-16 16H3.414zM5 34h24v19H5zm36 19V39h8v14zm19-21a1 1 0 0 0-1 1v20h-8V38a1 1 0 0 0-1-1H40a1 1 0 0 0-1 1v15h-8V33a1 1 0 0 0-1-1h-.586L45 16.414 60.586 32z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M45 24c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3c0 1.655-1.345 3-3 3zM26 37H8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V38a1 1 0 0 0-1-1zM9 39h7v8H9zm16 8h-7v-8h7z",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvroofDisabled);
export default __webpack_public_path__ + "static/media/pvroof_disabled.f90c0ce23960c54c4c62653ff9d2ca6b.svg";
export { ForwardRef as ReactComponent };